import styled from "@emotion/styled";
import { Card, Stack } from "react-bootstrap";
import THEME from "../../theme/index";
import { IStyledComponentProps } from "../../theme/theme.types";

export const DEFAULT_CARD_STYLES = `
    color: ${THEME.CE_THEME.colors.essential.grayDark};
    border-radius: 0;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.2);
    margin-bottom: 24px;
    .spinner-container {
      display: flex;
      min-height: 300px;
      align-items: center;
      justify-items: center;

      svg {
        margin: auto;
        flex: 1;
      }
    }
`;

export const DetailsCardBody = styled(Card.Body)<IStyledComponentProps>`
  &.details-card-body {
    padding: 0;
  }
`;

export const DetailsListHeader = styled(Stack)<IStyledComponentProps>`
  &.details-list-header {
    margin: 16px;

    h4 {
      font-family: ${({ theme }) => theme.fontFamilies.semiBold};
    }

    a {
      text-decoration: none;
    }

    &.bordered {
      border-bottom: 1px solid ${({ theme }) => theme.colors.grays.tertiary};
      margin: 0;
      padding: 16px 16px 0px 16px;
    }

    @media (max-width: ${(props) =>
        props.theme.utils.getThemeBreakpoint("tablet")}) {
      margin: 16px 0;

      h4 {
        margin-bottom: 0;
      }

      &.bordered {
        padding: 16px 0 0 0;
      }
    }
  }
`;

export const DetailsList = styled(Stack)<IStyledComponentProps>`
  &.details-list {
    border-bottom: 1px solid ${({ theme }) => theme.colors.grays.tertiary};
    padding-bottom: 24px;
  }
`;
